/**
 * Story Studio contract schemas (Zod 4) — the single source of truth for
 * every JSON shape in ARCHITECTURE.md §4. `shared/schemas/*.schema.json` is
 * generated from these by `scripts/emit-schemas.ts`; the backend's pydantic
 * models validate against those files.
 *
 * Each module exports the Zod schema and the inferred TypeScript type under
 * the same name (`StageAnnotation` is both a value and a type).
 */
export * from './common';
export * from './stage';
export * from './character';
export * from './object';
export * from './vocabulary';
export * from './story';
export * from './settings';
export * from './jobs';
export * from './events';
export * from './lessons';

import { z } from 'zod';
import { CharacterAnnotation } from './character';
import { ApiError, CostLedgerRow, Job, Proposal } from './jobs';
import { ObjectAnnotation } from './object';
import { Settings } from './settings';
import { StageAnnotation } from './stage';
import { AuthoringOutline, AuthoringScenes, Bundle, StoryScript } from './story';
import { Vocabulary } from './vocabulary';
import { EventPlan } from './events';

/**
 * The published contract set, keyed by the file stem written to
 * `shared/schemas/<name>.schema.json` (§3.0). Order is the emit order.
 */
export const CONTRACTS = {
  'stage-annotation': StageAnnotation,
  'character-annotation': CharacterAnnotation,
  'object-annotation': ObjectAnnotation,
  vocabulary: Vocabulary,
  'story-script': StoryScript,
  'story-events': EventPlan,
  'authoring-scenes': AuthoringScenes,
  'authoring-outline': AuthoringOutline,
  bundle: Bundle,
  job: Job,
  'cost-ledger-row': CostLedgerRow,
  proposal: Proposal,
  'api-error': ApiError,
  settings: Settings,
} as const satisfies Record<string, z.ZodType>;

export type ContractName = keyof typeof CONTRACTS;
export const CONTRACT_NAMES = Object.keys(CONTRACTS) as ContractName[];
